import React from 'react'
import { translations } from '../data/translations'

const SortControls = ({
  activeView,
  sortBy,
  setSortBy,
  sortOrder,
  setSortOrder,
  resetFilters,
  filteredCount,
  totalCount,
  language,
}) => {
  const t = translations[language]

  const sortOptions = {
    cards: [
      { value: 'name', label: t.filters.name },
      { value: 'cost', label: t.filters.byCost },
      { value: 'power', label: t.filters.byPower },
    ],
    locations: [
      { value: 'name', label: t.filters.name },
      { value: 'rarity', label: t.filters.byRarity },
    ],
    titles: [{ value: 'name', label: t.filters.name }],
    articles: [
      { value: 'date', label: t.filters.byDate },
      { value: 'name', label: t.filters.name },
    ],
  }

  const validSortBy = sortOptions[activeView].some((option) => option.value === sortBy)
    ? sortBy
    : sortOptions[activeView][0].value

  const sortOrderOptions =
    activeView === 'articles'
      ? [
          { value: 'desc', label: t.filters.desc },
          { value: 'asc', label: t.filters.asc },
        ]
      : [
          { value: 'asc', label: t.filters.asc },
          { value: 'desc', label: t.filters.desc },
        ]

  return (
    <div className="sort-wrapper">
      <div className="count-display">
        <h2 className="filter-counter-title">
          {t.filters.shown}:{' '}
          <span className="filter-counter-show-underlined">
            {filteredCount}/{totalCount}
          </span>
        </h2>
      </div>

      <div className="sort-controls">
        <h4>{t.filters.sort}</h4>

        <select value={validSortBy} onChange={(event) => setSortBy(event.target.value)}>
          {sortOptions[activeView].map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>

        <select value={sortOrder} onChange={(event) => setSortOrder(event.target.value)}>
          {sortOrderOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>

        <button className="reset-button" onClick={resetFilters} type="button">
          {t.filters.reset}
        </button>
      </div>
    </div>
  )
}

export default SortControls
